import {
    Row, Col, Form, Button, Modal, Switch, Flex, List
} from 'antd';
import {
    CheckOutlined, CloseOutlined
} from '@ant-design/icons';
import React, {useEffect, useState} from "react";
import { useTranslation } from "react-i18next";
import { showApiError } from "../../utility/error/error-handler";
import { getMaintenanceServices } from "../../api/maintenance";
import DataCard from '../../components/data/DataCard';
import useOnlineStatus from "../../utility/hooks/useOnlineStatus";

const ServicesCardView = ({vehicle, isViewServiceModalVisible, setIsViewServiceModalVisible, services, notification, setNavigatedFromServices, clickCreateNewRequestButton}) => {
  const { t } = useTranslation();
  const { isOnline } = useOnlineStatus();
  const [ loadingProgress, setLoadingProgress ] = useState(0);  //start 0 - button shows loading if less than 100
  const [ includeCompletedOrSkipped, setIncludeCompletedOrSkipped ] = useState(false);
  const [ maintenanceServices, setMaintenanceServices ] = useState(null);

  const refreshVehicleServices = (includeAll) => {
    setIncludeCompletedOrSkipped(includeAll);
  }

  useEffect(() => {
    if (vehicle)
      {
        getMaintenanceServices(vehicle.vehicleId, includeCompletedOrSkipped, setLoadingProgress)
        .then(res => {
          setMaintenanceServices(res);
        },)
        .catch(err => {
          showApiError(t('title.service_schedule'), err, notification);
        });          
      }
  }, [t, notification, vehicle, includeCompletedOrSkipped]);   

  const ServiceDistanceField = ({serviceDistance}) => {
    return (
             (serviceDistance !== null && serviceDistance !== undefined)
             ?
             <Row>
               <Col >{ t('field.distance') }</Col>
               <Col span={1}>:</Col>
               <Col >{serviceDistance}</Col>
             </Row>
             :
             <div> </div>
           )
  }

  function ServicesCardView({services}) {
    return (
             (services && services.length > 0)
             ?
             <div style={{height: 350,overflow: 'auto',}}>
               <Flex vertical>
                 <List>
                    {services.map(service => (
                       <List.Item key={services.id}>
                         <DataCard
                            header={service.serviceDescription}
                         >
                           <Row>
                             <Col>{ t('field.duedate') }</Col>
                             <Col span={1}>:</Col>
                             <Col>{service.projectedDueDate}</Col>
                           </Row>
                           <ServiceDistanceField serviceDistance={service.projectedDistance}></ServiceDistanceField>
                           <Row>
                             <Col >{ t('field.status') }</Col>
                             <Col span={1}>:</Col>
                             <Col > {service.status}</Col>
                           </Row>
                         </DataCard>                
                       </List.Item>
                    ))}
                 </List>
               </Flex>
             </div>
             :
             <div></div>
           )
  }    

return (
         <Modal className="std-portal-popup dp-wrap-card-title" 
                open={isViewServiceModalVisible && (services || maintenanceServices)}
                title={t('title.service_schedule')}
                closable={true}
                keyboard={true}
                footer={
                         isOnline
                         ?
                         [
                          <Button type="primary" 
                                  loading={loadingProgress !== 100 && !vehicle} 
                                  onClick={(e) => {
                                    setIsViewServiceModalVisible(false); 
                                    setIncludeCompletedOrSkipped(false);
                                    setNavigatedFromServices(true);
                                    clickCreateNewRequestButton(e);
                                  }}
                          >
                            {t('title.booking_requests')}
                          </Button>
                        ]
                        :
                        <> </>
                      }
                onCancel={() => {
                  setIsViewServiceModalVisible(false);
                  setIncludeCompletedOrSkipped(false);
                }}
         >
           <Form.Item name="includeCompletedOrSkipped" 
                      label={t('field.includeCompletedOrSkipped')}
                      layout='horizontal'
                      initialValue={false}
           >
             <Switch checkedChildren={ <CheckOutlined/> } 
                     unCheckedChildren={ <CloseOutlined/> }
                     checked={includeCompletedOrSkipped}
                     onChange={ (value) => {
                       refreshVehicleServices(value);
                     }}
             />
           </Form.Item>                           
           <ServicesCardView services={maintenanceServices} />                                                
         </Modal> 
       );
}

export default ServicesCardView;